import React, { ReactNode } from 'react';
import { getLowestPrice } from '../utils/getLowestPrice';
import { PricingContext } from './PricingContext';
import type { ProductPrices } from '../types';

export type StaticPricingProviderProps = {
    productPrices: ProductPrices;
    children: ReactNode;
};

export const StaticPricingProvider: React.FC<StaticPricingProviderProps> = ({
    productPrices,
    children,
}) => {
    const lowestPrice = getLowestPrice(productPrices);

    return (
        <PricingContext.Provider
            value={{ productPrices, lowestPrice, loading: false, error: undefined }}
        >
            {children}
        </PricingContext.Provider>
    );
};
